import DOMPurify from 'dompurify';

export default (html: string): string => {
  const sanitizedHtml: string = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'div',
      'span',
      'b',
      'li',
      'ol',
      'ul',
      'p',
      'strong',
      'em',
      'del',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'table',
      'thead',
      'tbody',
      'tr',
      'th',
      'td',
      'hr',
      'br',
      'ruby',
      'rt',
      'dd',
      'dt',
      'dl',
      'a',
      'video',
      'audio',
    ],
  });
  return sanitizedHtml;
};
